module.exports = __webpack_public_path__ + "img/m-wash3prousa-front.1a4e4626.jpg";